import { Boolean, Number, Record, Static, String } from "runtypes";

export const SurveyCoachEvaluationRequestRuntype = Record({
  coachCommitments: String,
  directorComments: String,
  parentComments: String,
  schoolId: Number,
  submitted: Boolean,
});

export interface ISurveyCoachEvaluationRequest
  extends Static<typeof SurveyCoachEvaluationRequestRuntype> {}



// WEBPACK FOOTER //
// ./src/api/types/ISurveyCoachEvaluationRequest.ts